import React, { useEffect, useState } from "react";
import { line } from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
        const footerSection2 = gsap.from(".gsapAboutus", {
          opacity: 0,
          duration: 1,
          x: 500,
          scrollTrigger: {
            trigger: ".gsapAboutus",
            scroller: "body",
            markers: false,
            start: "top 100%",
          },
        });
        ScrollTrigger.matchMedia({
          "(max-width: 800px)": function () {
            footerSection2.vars.x = 0;
          },
        });
    }
  });
  useGSAP(() => {
    if (!isMobile) {
        const footerSection2 = gsap.from(".gsapAboutus2", {
          opacity: 0,
          duration: 1,
          x: -500,
          scrollTrigger: {
            trigger: ".gsapAboutus2",
            scroller: "body",
            markers: false,
            start: "top 100%",
          },
        });
        ScrollTrigger.matchMedia({
          "(max-width: 800px)": function () {
            footerSection2.vars.x = 0;
          },
        });
    }
  });

  return (
    <div
      className="about-container"
      style={{ paddingTop: "60px", width: "100%", height: "auto" }}
    >
      <div
        className="h1_div"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img className="img-size" src={line} alt="" />
        <h1
          style={{
            textAlign: "center",
            fontSize: "40px",
            padding: "26px 0px",
            margin: "0px 20px",
          }}
          className="titlesFontFamily"
        >
          About Us
        </h1>
        <img className="img-size" src={line} alt="" />
      </div>

      <div className="about-image-container">
        <div
          className="image-div fullWidth gsapAboutus2 "
          style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            style={{ width: "700px", borderRadius: "10px" }}
            src="https://www.unexplora.com/wp-content/uploads/2019/10/IMG-20180712-WA0026.jpg"
            alt="A beautiful landscape"
            className="about-image"
          />
        </div>
        <div className="about-info gsapAboutus" style={{ width: "50%", height: "auto",marginLeft:"60px" }}>
          <h2 style={{ marginBottom: "10px",fontSize:"35px" }} className="titlesFontFamily">Welcome to Our Luxury Villas</h2>
          <p style={{ marginBottom: "8px",fontSize:"16px",color:"darkslategrey",lineHeight:"1.5" }}>
            Eagle Villa, serene and luxurious retreat conveniently located just
            5km from Wet n Joy water park in Lonavala. Enjoy stunning views of
            lush greenery and mountains. With air-conditioned rooms,
            complimentary Wi-Fi, and invigorating showers, solo travelers can
            find ultimate comfort. Start the day with a delicious breakfast in
            your room. Take a dip in the pool while enjoying panoramic vistas.
          </p>
          <p style={{ marginBottom: "8px",fontSize:"16px",color:"darkslategrey",lineHeight:"1.5" }}>
            Nature Resort is in the heart of nature for relaxing your mind &
            body. Swimming Pool with slide for family and also children's play
            area & 24 hours housekeeping and reception for guests.It's away from
            the crowd as one who visits us comes for peace and serenity.As we
            believe in satisfaction of our customers, we provide our guests with
            all modern amenities.
          </p>
          <p style={{fontSize:"16px",color:"darkslategrey",lineHeight:"1.5"}}>
            Conveniently located near Wet N Joy, our villa is perfect for guests
            looking to enjoy thrilling water rides and attractions. After a
            fun-filled day at the park, return to your luxurious haven and
            unwind in style.{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
